"use client";

import GeneralErrorPage from "@portal/components/pages/generalErrorPage";

const ErrorPage = () => {
  return <GeneralErrorPage />;
};

export default ErrorPage;
